@if ((card?.template?.gameplay?.type??'') === 'stack') {
  <div class="gameplay__container__box stack__container">
    <mat-card class="card__container">
      <mat-card-content class="card__content">
      <nx-superprep-slide-panel [activePane]="activePane" [duration]="slideDuration">
          <div leftPane>
            <ng-container [ngTemplateOutlet]="stackTemplate"></ng-container>
          </div>
          <div rightPane>
            <ng-container [ngTemplateOutlet]="stackTemplate"></ng-container>
          </div>
      </nx-superprep-slide-panel>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #stackTemplate>
  <div class="header__container" [style.min-height]="headerContainerHeight">
    <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
  </div>
  <div  class="choice__list__container">
    <ng-container
      [ngTemplateOutlet]="threeButtonStack"
      [ngTemplateOutletContext]="{
        didAnswer: didAnswer,
        choices: choices
      }"
    ></ng-container>
  </div>
</ng-template>

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [style.margin]="question?.isImage ? '0' : 'initial'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if (shouldShowTextContent) {
    <div
      class="text__content"
      [ngClass]="didAnswer ? 'endText' : 'questionText'"
      [style.min-height]="'3.5rem'"
      [style.visibility]="isTextContentVisible ? 'visible' : 'hidden'"
      [style.cursor]="didPlayAudio && !shouldShowPlayButton ? 'pointer' : 'unset'"
      [innerHTML]="(didAnswer ? endText() : questionText()) | safe: 'html'"
      (mousedown)="shouldShowPlayButton ? '' : onPlayButtonTap()"
    ></div>
  }
  @if (shouldShowPlayButton) {
    <div class="audio__container" [ngClass]="isVisualMedia ? 'lifted' : ''">
      <nx-superprep-play-button
          #audioButton
          [duration]="audioDuration"
          [diameter]="playButtonDiameter"
          (action)="onPlayButtonTap($event)"
        >
      </nx-superprep-play-button>
    </div>
  }
  @if (hasTranslation) {
    <ng-container
      [ngTemplateOutlet]="translationTemplate"
      [ngTemplateOutletContext]="{
        didAnswer: didAnswer,
        translation: translation(),
        pronunciation: pronunciation(),
        shouldShowTranslation: shouldShowTranslation,
        shouldShowPronunciation: shouldShowPronunciation
      }"
    ></ng-container>
  }
  <div class="media__container">
    <ng-container
      [ngTemplateOutlet]="mediaTemplate"
    ></ng-container>
  </div>
</ng-template>

<ng-template #mediaTemplate>
  @if (question?.isVideo || (didAnswer && answer?.hasVideo)) {
    <div class="video__container" [ngClass]="isMediaOnly ? 'imageonly' : ''">
      <video class="video" autoplay playsinline loop muted preload="auto" #video
        src="{{videoUrl}}" type="video/mp4">
        Browser not supported
      </video>
    </div>
  }
  @if (question?.isImage || (didAnswer && answer?.isImage)) {
    <div
      class="choice__container__box noborder"
      [ngClass]="isMediaOnly ? 'imageonly' : ''"
    >
      @if (question?.image || (didAnswer && answer?.image)) {
        <img
          mat-card-img
          class="image__container border"
          [src]="didAnswer ? answer?.imageUrl : question?.imageUrl"
        />
      }
      <div class="frame40pxspacer"></div>
    </div>
  } @else if (didAnswer && answer?.isElement) {
    <div class="text__container">
      <svg width="100%" height="100%">
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          rx="20"
          ry="20"
          opacity="0.5"
          stroke="transparent"
          stroke-width="8px"
          fill="transparent"
        />
        <text
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          [innerHTML]="elementText() | safe: 'html'"
        ></text>
      </svg>
    </div>
  }
</ng-template>

<ng-template
  #translationTemplate
  let-didAnswer="didAnswer"
  let-translation="translation"
  let-pronunciation="pronunciation"
  let-shouldShowTranslation="shouldShowTranslation"
  let-shouldShowPronunciation="shouldShowPronunciation"
>
  <div class="translation__container">
    <p class="translation"
      [style.visibility]="shouldShowTranslation ? 'visible' : 'hidden'"
      [innerHTML]="translation | safe: 'html'"
    ></p>
    <p class="pronunciation"
      [style.visibility]="shouldShowPronunciation ? 'visible' : 'hidden'"
      [innerHTML]="pronunciation | safe: 'html'"
    ></p>
  </div>
</ng-template>

<ng-template
  #threeButtonStack
  let-didAnswer="didAnswer"
  let-choices="choices"
>
  <mat-grid-list cols="1" rowHeight="{{rowHeight}}" gutterSize="{{gutterSize}}">
    @for (choice of fittedChoices; track $index; let index = $index) {
      <mat-grid-tile
        [colspan]="1"
        [rowspan]="1"
        [ngClass]="{
          choice: true,
          border: true,
          text__container: true,
          limitheight: true,
          elevated: !didAnswer,
          selectable: !didAnswer,
          active: isActive(choice),
          correct: isCorrect(choice),
          translucid: didAnswer && !choice.isAnswer
        }"
        [style.visibility]="choice.name ? 'visible' : 'hidden'"
        [style.cursor]="didAnswer ? 'default' :  'pointer'"
        [@headShake]="isAnimated(choice)"
        (mousedown)="onSelect(choice)"
      >
        <ng-container
          [ngTemplateOutlet]="labelTemplate"
          [ngTemplateOutletContext]="{
            labels: [choiceLabel([choice, index])]
          }"
        ></ng-container>
      </mat-grid-tile>
    }
  </mat-grid-list>
</ng-template>

<ng-template
  #labelTemplate
  let-labels="labels"
>
  @if (labels.length > 1) {
    <carousel
      class="container-fluid"
      [interval]="interval"
      [showIndicators]="showIndicators"
      [isAnimated]="false"
    >
      @for (label of labels; track $index) {
        <slide>
          <span class="text__content" [innerHTML]="label | safe: 'html'"></span>
        </slide>
      }
    </carousel>
  } @else {
    <span class="text__content" [innerHTML]="labels[0] | safe: 'html'"></span>
  }
</ng-template>
